import { render, staticRenderFns } from "./AlertsListPage.vue?vue&type=template&id=36102531&scoped=true&"
import script from "./AlertsListPage.vue?vue&type=script&lang=ts&"
export * from "./AlertsListPage.vue?vue&type=script&lang=ts&"
import style0 from "./AlertsListPage.vue?vue&type=style&index=0&id=36102531&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36102531",
  null
  
)

export default component.exports